import { Routes } from '@angular/router';
import { ConnectorAuthGuard as ConnectorAuthGuard } from 'src/shared/services/common/connector-auth-guard.service';
import { IdasAuthGuard } from 'src/shared/services/common/idas-auth-guard.service';
import { AuthGuard } from '../shared/services/common/auth-guard.service';
import { ConnectorOnsetComponent } from './connector-onset/connector-onset.component';
import { ConnectorComponent } from './connector/connector.component';
import { DemoComponent } from './demo/demo.component';
import { HomeComponent } from './home/home.component';
import { IdasOnsetComponent } from './idas-onset/idas-onset.component';
var routes = [
    { path: '', component: HomeComponent },
    { path: 'demo', component: DemoComponent },
    { path: 'connector', component: ConnectorComponent },
    { path: 'connector-onset', component: ConnectorOnsetComponent, canActivate: [ConnectorAuthGuard] },
    { path: 'idas-onset', component: IdasOnsetComponent, canActivate: [IdasAuthGuard] },
    { path: 'onset-with-tan', loadChildren: './onset-with-tan/onset-with-tan.module#OnsetWithTanModule', canActivate: [AuthGuard] },
    { path: '**', component: HomeComponent },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
